import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Plus } from 'lucide-react'
import { ManageTable, type ManageField } from '@/components/ManageTable'
import { usePersistentState } from '@/hooks/usePersistentState'

const escapeRegex = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export default function Interface() {
  const navigate = useNavigate()
  const [filterValues, setFilterValues, clearFilters] = usePersistentState<
    Record<string, string>
  >(
    'admin:interface:filters',
    {},
  )
  const filters = Object.fromEntries(
    Object.entries(filterValues)
      .filter(([, value]) => value.trim())
      .map(([field, value]) => [
        field,
        { $regex: `.*${escapeRegex(value.trim())}.*`, $options: 'i' },
      ]),
  )

  const handleResetFilters = () => {
    clearFilters()
  }

  const fields: ManageField[] = [
    {
      desc: '名称',
      field: 'name',
      NoShowInTable: true,
    },
    {
      desc: '路径',
      field: 'path',
      render: (val) => <span className="font-mono text-sm">{val}</span>,
    },
    {
      desc: '描述',
      field: 'desc',
    },
    {
      desc: '更新时间',
      field: 'update_time',
      render: (val) => <span className="text-sm">{val}</span>,
    },
  ]

  const filterUI = (
    <div className="flex items-center gap-4 flex-wrap">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium">路径:</span>
        <Input
          className="w-[200px]"
          placeholder="输入路径片段"
          value={filterValues.path || ''}
          onChange={(e) => {
            const newFilters = { ...filterValues }
            if (e.target.value) {
              newFilters.path = e.target.value
            } else {
              delete newFilters.path
            }
            setFilterValues(newFilters)
          }}
        />
      </div>

      <div className="flex items-center gap-2">
        <span className="text-sm font-medium">描述:</span>
        <Input
          className="w-[200px]"
          placeholder="输入描述关键词"
          value={filterValues.desc || ''}
          onChange={(e) => {
            const newFilters = { ...filterValues }
            if (e.target.value) {
              newFilters.desc = e.target.value
            } else {
              delete newFilters.desc
            }
            setFilterValues(newFilters)
          }}
        />
      </div>
    </div>
  )

  const customAddButton = (
    <Button onClick={() => navigate('/admin/interface/add')}>
      <Plus className="h-4 w-4 mr-2" />
      添加接口
    </Button>
  )

  const customActions = (row: any) => (
    <>
      <Button size="sm" onClick={() => navigate(`/admin/interface/${row.id}`)}>
        编辑
      </Button>
    </>
  )

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">接口管理</h1>
      <ManageTable
        fields={fields}
        collect="system_apis"
        filters={filters}
        filter={filterUI}
        onResetFilters={handleResetFilters}
        customAddButton={customAddButton}
        customActions={customActions}
      />
    </div>
  )
}
